import * as Yup from 'yup';
import { Validator } from 'components/Forms/Address/Templates/FullAddress';
import { telephoneValidation } from 'utils/form/validation';
import { optionalStringValidationSchema } from 'utils/form/validation/index';

export default Yup.object().shape({
  address: Yup.object().shape(Validator.getShape()),
  email: Yup.string().email('Please provide correct email address.'),
  contactNumber: telephoneValidation(),
  submissionRoute: optionalStringValidationSchema('network', (networkValue) => !networkValue),
});
